import { render, staticRenderFns } from "./wyMobileDownload.vue?vue&type=template&id=6d175ef9&scoped=true"
import script from "./wyMobileDownload.vue?vue&type=script&lang=js"
export * from "./wyMobileDownload.vue?vue&type=script&lang=js"
import style0 from "./wyMobileDownload.vue?vue&type=style&index=0&id=6d175ef9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d175ef9",
  null
  
)

export default component.exports